module.exports = __webpack_public_path__ + "static/back-916605b60546b35b65105cde1d5c5f44.svg";